module.exports = __webpack_public_path__ + "img/footer-icon.58f55c5c.png";